module.exports = __webpack_public_path__ + "img/Zipcode.4c2de689.svg";